<div class="container">
	<div class="row">
		<!--  Admin org select  -->
		<div *ngIf="api.user.role === 'admin' || api.user.role === 'master'" class="col-sm-12">
			<div class="item-panel">
				<div class="heading">Global admin only - select organization</div>
				<div class="content">
					<div class="row">
						<div class="col-sm-6">
							<div class="form-group">
								<label>Organization name</label>
								<select [ngModel]="organization" (ngModelChange)="SelectOrganization($event)" class="form-control">
									<option *ngFor="let org of organizations" [ngValue]="org">{{org.name}}</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  User select / add  -->
		<div class="col-sm-12">
			<div class="item-panel">
				<div class="heading">Users for {{organization.name}}</div>
				<div class="content">
					<div class="row">
						<div class="col-sm-6 mb-3">
							<div class="list-group mb-3">
								<a *ngFor="let user of users" (click)="SelectUser(user)" [class.active]="selecteduser === user" href="javascript:void(0)"
									class="list-group-item list-group-item-action d-flex align-items-center justify-content-between">
									<span>{{user.email}}</span>
									<span *ngIf="user.role === 'readonly'" class="badge badge-secondary">Read Only</span>
									<span *ngIf="user.role === 'orgadmin'" class="badge badge-success">Org Admin</span>
									<span *ngIf="user.role === 'admin'" class="badge badge-danger">Global Admin</span>
									<span *ngIf="user.role === 'master'" class="badge badge-primary">Master Admin</span>
								</a>
							</div>
							<div *ngIf="!showadduser">
								<button (click)="showadduser = true" class="btn btn-primary">
									<i class="icon-plus-circled"></i>Add a new user</button>
							</div>
							<div *ngIf="showadduser">
								<hr>
								<h5 class="mb-4">
									<b>Add a new user</b>
								</h5>
								<div *ngIf="!brand.localCloud" class="form-group row">
									<label class="col-md-4">Email address</label>
									<div class="col-md-8">
										<input [(ngModel)]="adduser.email" type="email" class="form-control">
									</div>
								</div>
								<div *ngIf="brand.localCloud" class="form-group row">
									<label class="col-md-4">User name</label>
									<div class="col-md-8">
										<input [(ngModel)]="adduser.email" type="text" class="form-control">
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4">Password</label>
									<div class="col-md-8">
										<input [(ngModel)]="adduser.password" type="password" class="form-control" autocomplete="new-password">
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4">Role:</label>
									<div class="col-md-8">
										<div class="form-check">
											<label class="form-check-label">
												<input [(ngModel)]="adduser.role" type="radio" class="form-check-input" value="orgadmin">
												Organization Administrator
											</label>
										</div>
										<div class="form-check">
											<label class="form-check-label">
												<input [(ngModel)]="adduser.role" type="radio" class="form-check-input" value="user"> User
											</label>
										</div>
										<div class="form-check">
											<label class="form-check-label">
												<input [(ngModel)]="adduser.role" type="radio" class="form-check-input" value="readonly"> Read
												Only
											</label>
										</div>
									</div>
								</div>
								<div *ngIf="addusererrormessage" class="form-group row">
									<div class="col-md-8 offset-md-4">
										<div class="message-bad">{{addusererrormessage}}</div>
									</div>
								</div>
								<div class="col-md-8 offset-md-4">
									<button (click)="AddUser()" class="btn btn-success">Add User</button>
									<button (click)="showadduser = false" class="btn btn-primary">Cancel</button>
								</div>
							</div>
						</div>
						<div *ngIf="!selecteduser" class="col-sm-6">
							No user selected
						</div>
						<div *ngIf="selecteduser" class="col-sm-6">
							<h4 class="form-group">{{selecteduser.email}}</h4>
							<div *ngIf="(selecteduser.role !== 'admin' && selecteduser.role !== 'master') && selecteduser.user_id !== api.user.user_id" class="form-group">
								<hr>
								<div class="form-group row">
									<label class="col-md-4">Role:</label>
									<div class="col-md-8">
										<div class="form-check">
											<label class="form-check-label">
												<input [ngModel]="selecteduser.role" (ngModelChange)="newrole=$event" type="radio" class="form-check-input" value="orgadmin"> Organization Administrator
											</label>
										</div>
										<div class="form-check">
											<label class="form-check-label">
												<input [ngModel]="selecteduser.role" (ngModelChange)="newrole=$event" type="radio" class="form-check-input" value="user"> User
											</label>
										</div>
										<div class="form-check">
											<label class="form-check-label">
												<input [ngModel]="selecteduser.role" (ngModelChange)="newrole=$event" type="radio" class="form-check-input" value="readonly"> Read Only
											</label>
										</div>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-md-4">Hide views:</label>
									<div class="col-md-8">
										<div class="form-check">
											<label class="form-check-label">
												<input [(ngModel)]="selecteduser.hide_rtb" type="checkbox" class="form-check-input"> RTB
											</label>
										</div>
										<div class="form-check">
											<label class="form-check-label">
												<input [(ngModel)]="selecteduser.hide_fdm" type="checkbox" class="form-check-input"> FDM
											</label>
										</div>
										<div class="form-check">
											<label class="form-check-label">
												<input [(ngModel)]="selecteduser.hide_mech" type="checkbox" class="form-check-input"> Mechanical
											</label>
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-8 offset-md-4">
										<app-action-button [action]="UpdateUser" [context]="this" processing="Updating..." complete="User updated" btnClass="btn-primary">Update
											User</app-action-button>
									</div>
								</div>
							</div>
							<div
								*ngIf="((selecteduser.role !== 'admin' && selecteduser.role !== 'master') || api.user.role === 'admin' || api.user.role === 'master') && (selecteduser.user_id !== api.user.user_id)"
								class="form-group">
								<hr>
								<div class="form-group row">
									<div class="col-lg-7">
										<input type="password" [(ngModel)]="newpassword" class="form-control" placeholder="New password">
									</div>
									<div class="col-lg-5">
										<app-action-button [action]="SetPassword" [context]="this" processing="Updating..." complete="Password reset" btnClass="btn-primary btn-block">Reset
											Password</app-action-button>
									</div>
								</div>
							</div>
							<div
								*ngIf="((selecteduser.role !== 'admin' && selecteduser.role !== 'master') || api.user.role === 'admin' || api.user.role === 'master') && (selecteduser.user_id !== api.user.user_id)"
								class="form-group">
								<hr>
								<div class="form-group row">
									<div class="col-lg-7">
										<input type="email" [(ngModel)]="newemail" class="form-control" placeholder="New email">
									</div>
									<div class="col-lg-5">
										<app-action-button [action]="RenameUser" [context]="this" processing="Updating..." complete="Email changed, please refresh"
											btnClass="btn-primary btn-block">Change
											Email</app-action-button>
									</div>
								</div>
							</div>
							<div>
								<hr>
								<div class="form-group row">
									<div class="col-lg-7">
										<label>Send a test email</label>
									</div>
									<div class="col-lg-5">
										<app-action-button [action]="SendEmail" [context]="this" processing="Sending..." complete="Email sent" btnClass="btn-primary btn-block">Send
											Email</app-action-button>
									</div>
								</div>
							</div>
							<div *ngIf="(selecteduser.role !== 'admin' || selecteduser.role !== 'master') && selecteduser.user_id !== api.user.user_id" class="form-group">
								<hr>
								<div class="form-group row">
									<div class="col-lg-7">
										<label>Permanently delete this user</label>
									</div>
									<div class="col-lg-5">
										<app-action-button [action]="DeleteUser" [context]="this" processing="Deleting..." complete="User deleted" btnClass="btn-primary btn-danger btn-block"
											confirm="Permanently delete this user?">Delete User</app-action-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  Asset select / add  -->
		<div class="col-sm-12">
			<div class="item-panel">
				<div class="heading">Assets for {{organization.name}}</div>
				<div class="content">
					<div class="row">
						<div class="col-sm-6 mb-3">
							<div class="list-group mb-3">
								<a *ngFor="let asset of assets" (click)="SelectAsset(asset)" [class.active]="selectedasset === asset" href="javascript:void(0)"
									class="list-group-item list-group-item-action d-flex align-items-center justify-content-between">
									<span>{{asset.asset_name}} ({{asset.obcu_serial_number}})</span>
									<span *ngIf="asset.fleet_id" class="badge badge-success">{{asset.fleet_name}}</span>
									<span *ngIf="!asset.fleet_id" class="badge badge-danger">Not assigned</span>
								</a>
							</div>
						</div>
						<div *ngIf="!selectedasset" class="col-sm-6">
							No asset selected
						</div>
						<div *ngIf="selectedasset" class="col-sm-6">
							<h4 class="form-group">OBCU: {{selectedasset.obcu_serial_number}}</h4>
							<hr>
							<div class="form-group row">
								<label class="col-md-4">Configuration Type:</label>
								<div class="col-md-8">
									<select [(ngModel)]="updateasset.config" class="form-control">
										<option *ngFor="let config of configs" [ngValue]="config">{{config.asset_type_name}}</option>
									</select>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-md-4">Asset name</label>
								<div class="col-md-8">
									<input [(ngModel)]="updateasset.asset_name" type="text" class="form-control">
								</div>
							</div>
							<div class="form-group row">
								<label class="col-md-4">{{brand.fleetSingular}}:</label>
								<div class="col-md-8">
									<select [(ngModel)]="updateasset.fleet" class="form-control">
										<option *ngFor="let fleet of fleets" [ngValue]="fleet">{{fleet.fleet_name}}</option>
									</select>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-md-4">Total flight time offset (hrs):</label>
								<div class="col-md-8">
									<input type="number" [(ngModel)]="updateasset.flight_time_offset" class="form-control">
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-8 offset-md-4">
									<app-action-button [action]="UpdateAsset" [context]="this" processing="Updating..." complete="Asset updated" btnClass="btn-primary">Update
										Asset</app-action-button>
								</div>
							</div>
							<p>Note that changing these parameters requires that the OBCU configuration be updated to match exactly.
								Any incoming
								data with different values will be discarded.</p>
							<div *ngIf="assetPartners && assetPartners.length > 0">
								<hr>
								<h5>Partner sharing</h5>
								<div>Note: this asset is being shared with:</div>
								<ul class="partner-list">
									<li *ngFor="let partner of assetPartners">
										{{ partner }}
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  Fleet select / add  -->
		<div class="col-sm-12">
			<div class="item-panel">
				<div class="heading">{{brand.fleetPlural}} for {{organization.name}}</div>
				<div class="content">
					<div class="row">
						<div class="col-sm-6 mb-3">
							<div class="list-group mb-3">
								<a *ngFor="let fleet of fleets" (click)="SelectFleet(fleet)" [class.active]="selectedfleet === fleet" href="javascript:void(0)"
									class="list-group-item list-group-item-action">
									<span>{{fleet.fleet_name}}</span>
								</a>
							</div>
							<div *ngIf="!showaddfleet">
								<button (click)="showaddfleet = true" class="btn btn-primary">
									<i class="icon-plus-circled"></i>Add a new {{brand.fleetSingular}}</button>
							</div>
							<div *ngIf="showaddfleet">
								<hr>
								<h5 class="mb-4">Add a new {{brand.fleetSingular}}</h5>
								<div class="form-group row">
									<label class="col-md-4">{{brand.fleetSingular}} name</label>
									<div class="col-md-8">
										<input [(ngModel)]="addfleetname" type="text" class="form-control">
									</div>
								</div>
								<div *ngIf="addfleeterrormessage" class="form-group row">
									<div class="col-md-8 offset-md-4">
										<div class="message-bad">{{addfleeterrormessage}}</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-8 offset-md-4">
										<button (click)="AddFleet()" class="btn btn-success">Add {{brand.fleetSingular}}</button>
										<button (click)="showaddfleet = false" class="btn btn-primary">Cancel</button>
									</div>
								</div>
							</div>
						</div>
						<div *ngIf="!selectedfleet" class="col-sm-6">
							No fleet selected
						</div>
						<div *ngIf="selectedfleet" class="col-sm-6">
							<h4 class="form-group">{{selectedfleet.fleet_name}}</h4>
							<hr>
							<div class="form-group row">
								<label class="col-md-4">Time display offset (hrs):</label>
								<div class="col-md-8">
									<input type="number" [(ngModel)]="selectedfleet.time_offset_hours">
								</div>
							</div>
							<div *ngIf="updatefleeterrormessage" class="form-group row">
								<div class="col-md-8 offset-md-4">
									<div class="message-bad">{{updatefleeterrormessage}}</div>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-8 offset-md-4">
									<app-action-button [action]="UpdateFleet" [context]="this" processing="Updating..." complete="{{brand.fleetSingular}} updated" btnClass="btn-primary">Update
										{{brand.fleetSingular}}
									</app-action-button>
								</div>
							</div>
							<hr>
							<div class="form-group row">
								<div class="col-md-6">Permanently delete this {{brand.fleetSingular}}</div>
								<div class="col-md-6">
									<app-action-button [action]="DeleteFleet" [context]="this" processing="Deleting..." complete="{{brand.fleetSingular}} deleted" btnClass="btn-danger btn-block"
										confirm="Are you sure? Any assets in this {{brand.fleetSingular}} will not be deleted but will need to be assigned to a different {{brand.fleetSingular}}.">
										Delete Fleet</app-action-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<app-footer></app-footer>
</div>